// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ProgressStepProps } from "@mcmc/App/Components/ProgressIndicator/ProgressStep";
import * as React from "react";
import { css } from "styled-components";

interface ProgressIndicatorProps {
    id?: string;
    children: React.ReactElement<ProgressStepProps>[];
}
type Props = ProgressIndicatorProps;

interface ProgressIndicatorStyles {
    wrapper: InjectableCss;
}

export const progressStepStyles: ProgressIndicatorStyles = {
    wrapper: {
        css: css`
            display: flex;
            overflow-y: hidden;
            overflow-x: auto;
            margin-bottom: 40px;
        `,
    },
};

const styles = progressStepStyles;

const ProgressIndicator: React.FC<Props> = ({ children, id }) => {
    return (
        <StyledWrapper {...styles.wrapper} id={id}>
            {children}
        </StyledWrapper>
    );
};

export default ProgressIndicator;
